import { TokenData } from '../models/token-data';

export const EMPTY_TOKEN_DATA: TokenData = {
  token_type: '',
  exp: 0,
  iat: 0,
  jti: '',
  user_id: '',
  hash_password: '',
  customer_id: '',
  timezone: '',
  employee_id: '',
  email: '',
  is_hijacked: false,
  iss: '',
};

/**
 * Decodes the payload of a JWT. Returns null instead of throwing when the
 * token is missing, not a JWT, or carries a malformed payload — callers
 * constructed eagerly (root services) must not crash on a bad token.
 */
export function decodeTokenData(token: string | null): TokenData | null {
  if (!token) return null;
  const payload = token.split('.')[1];
  if (!payload) return null;
  try {
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}
